import React from 'react';
import Div from "@jumbo/shared/Div";
import { Link as RouterLink } from 'react-router-dom';
import Link from "@mui/material/Link";
import { ASSET_IMAGES } from "../../utils/constants/paths";


const Logo = ({ mini, mode, sx }) => {
  return (
    <Div sx={{ display: "inline-flex", ...sx }}>
      <Link component={RouterLink} to='/' >
        {
          !mini ?
            <img height="40px" src={mode === "light" ? `${ASSET_IMAGES}/logos/Tri State.png` : `${ASSET_IMAGES}/Tri State.png`} alt="Tri State" />
            :
            <img height="40px" src={mode === "light" ? `${ASSET_IMAGES}/logos/Tri State.png` : `${ASSET_IMAGES}/Tri State.png`} alt="Tri State" />
        }
      </Link>
    </Div>
  );
};

Logo.defaultProps = {
  mode: "light"
};

export default Logo;
